import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { SessionWarningModal } from "@/components/auth/SessionWarningModal";
import { useSessionTimeout } from "@/hooks/useSessionTimeout";
export const SessionTimeoutProvider = ({ children })=>{
    const { showWarning, timeRemaining, continueSession, logout } = useSessionTimeout();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            children,
            /*#__PURE__*/ _jsx(SessionWarningModal, {
                isOpen: showWarning,
                timeRemaining: timeRemaining,
                onContinue: continueSession,
                onLogout: logout
            })
        ]
    });
};
